<template>
  <div>
    <v-client-table
        v-if="lignes.length > 0"
        :data="lignes"
        class='overflow-x-auto overflow-y-hidden'
        :columns="columns"
        :options="options"
        ref='tableFaces'>
      <template #presence="{ row }">
        <b-tooltip
            :label="$t(`optionBlocage.informationOptionBlocage.${
              row.presence ? 'faceIn' : 'faceNotIn'
            }`)"
            position="is-left">
          <div
            class="legende-square has-text-centered"
            :class="`has-background-${row.presence ? 'success' : 'danger'}`">
          </div>
        </b-tooltip>
      </template>
      <template v-slot:[`produit.reference`]="props">
        <div class="link">
          <router-link-blank
            :to="{ name: 'c.bodac.catalogue-face', params: { id: props.row.produitId }}"
            class="lien"
            :message="props.row.produit.reference">
          </router-link-blank>
        </div>
      </template>
    </v-client-table>
    <span v-else>{{ $t('optionBlocage.informationOptionBlocage.noAffectation') }}</span>
  </div>
</template>

<script>
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'ReseauOptionBlocageLignesDetail',
  components: {
    routerLinkBlank,
  },
  computed: {
    columns() {
      return ['produit.reference', 'produit.produitFace.format', 'produit.produitFace.materielType', 'produit.produitFace.adresse.adresse1', 'produit.produitFace.adresse.codePostal', 'produit.produitFace.adresse.ville', 'presence'];
    },
    options() {
      return {
        headings: {
          presence: '',
          'produit.reference': this.$i18n.t('catalogue.table.face'),
          'produit.produitFace.format': this.$i18n.t('catalogue.table.format'),
          'produit.produitFace.materielType': this.$i18n.t('catalogue.table.materiel'),
          'produit.produitFace.adresse.adresse1': this.$i18n.t('catalogue.table.adresse'),
          'produit.produitFace.adresse.codePostal': this.$i18n.t('catalogue.table.codePostal'),
          'produit.produitFace.adresse.ville': this.$i18n.t('catalogue.table.ville'),
        },
        headingsTooltips: {
          'produit.reference': this.$i18n.t('catalogue.table.face'),
        },
        columnsClasses: {
          adresse: 'ellipsis address',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortIcon: SORT_ICON,
        sortable: [
          'produit.reference',
          'produit.produitFace.format',
          'produit.produitFace.materielType',
          'produit.produitFace.adresse.adresse1',
          'produit.produitFace.adresse.codePostal',
          'produit.produitFace.adresse.ville',
        ],
      };
    },
  },
  props: {
    lignes: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>

</style>
